var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_51)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.274 10.1437C15.1302 10.2885 15.1146 10.4812 15.2302 10.7234C15.3432 10.9651 15.5854 11.2682 15.9547 11.6328C16.3234 11.9963 16.6307 12.2359 16.8766 12.35C17.124 12.4635 17.3187 12.4469 17.4615 12.3021C17.737 12.0234 17.5083 11.5224 16.776 10.8C16.0484 10.0833 15.5479 9.86405 15.274 10.1437Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6224 -0.00172424L0 14.6228L10.3786 24.9998L25.0016 10.3759V0.00140076L14.6224 -0.00172424ZM11.4047 15.1524C10.9328 15.6327 10.3943 15.8337 9.79167 15.7535C9.1901 15.6764 8.56302 15.316 7.9125 14.6738C6.5849 13.3634 6.4151 12.2071 7.40469 11.205C7.88854 10.7139 8.43281 10.5071 9.03646 10.5837C9.6401 10.6603 10.262 11.0144 10.9021 11.6452C11.5698 12.3045 11.9443 12.929 12.025 13.5181C12.1047 14.1087 11.8979 14.6535 11.4047 15.1524ZM13.812 17.6384L10.9281 7.81703L11.9604 6.77067L14.8432 16.5936L13.812 17.6384ZM18.351 13.1972C17.8776 13.6759 17.3396 13.8785 16.737 13.7983C16.1349 13.7207 15.5094 13.3623 14.8609 12.7228C13.5333 11.4123 13.3641 10.2561 14.3526 9.25296C14.8375 8.76234 15.3818 8.55505 15.9859 8.63213C16.5885 8.70869 17.2115 9.06234 17.85 9.69307C18.5156 10.3493 18.888 10.9738 18.9687 11.5629C19.05 12.153 18.8443 12.6983 18.351 13.1972ZM22.225 4.97484C21.6177 5.58161 20.6339 5.58161 20.0245 4.97588C19.4177 4.36703 19.4177 3.38265 20.0234 2.7738C20.6318 2.1665 21.6182 2.1665 22.225 2.77275C22.8339 3.38317 22.8349 4.36598 22.225 4.97484Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.32396 12.0943C8.17969 12.2401 8.16511 12.4338 8.28021 12.675C8.39375 12.9167 8.63594 13.2198 9.00469 13.5849C9.37344 13.949 9.68073 14.1875 9.92709 14.301C10.1729 14.4156 10.3688 14.4 10.512 14.2542C10.7859 13.9755 10.5583 13.4745 9.82657 12.7516C9.09948 12.0349 8.59844 11.8167 8.32396 12.0943Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_51"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscount);
export default __webpack_public_path__ + "static/media/discount.402216bc17e2727baaf82a1874a50bde.svg";
export { ForwardRef as ReactComponent };